import { render, staticRenderFns } from "./HotelsInfoWithFiltering.vue?vue&type=template&id=48b5ea4d&"
import script from "./HotelsInfoWithFiltering.vue?vue&type=script&lang=js&"
export * from "./HotelsInfoWithFiltering.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports